import { useAppSelector } from '@frontend/common';
import { EquipmentExtendedClient } from '@frontend/equipment/api';
import { EquipmentExtended } from '@frontend/equipment/types';
import { changeData, listStore } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../../redux/store';
import { EquipmentDetailProps } from './equipment-detail.component';

export const useEquipmentDetail = (props: EquipmentDetailProps) => {
    const dispatch = useAppDispatch();
    const list = useAppSelector(useSelector, listStore);
    const equipmentList = list['equipment-detail-equipment-list'];
    const [equipments, setEquipments] = useState<EquipmentExtended[] | null>(null);
    const [equipmentState, setEquipmentState] = useState<string | null>(null);

    useEffect(() => {
        EquipmentExtendedClient.fetchEquipmentsExtended({ account_id: props.product.account_id, product_id: props.product.id, state: equipmentState }).then(
            (res) => setEquipments(res.results)
        );
    }, [props.product, equipmentState]);

    useEffect(() => {
        if (!equipmentList || !equipments) return;
        dispatch(changeData({ listId: 'equipment-detail-equipment-list', data: equipments, replace: true }));
    }, [equipments]);

    return {
        equipments,
        dispatch,
        equipmentState,
        setEquipmentState
    };
};
